import { Component, OnInit } from '@angular/core';
import { HospitalityService } from 'src/app/shared/services/hospitality.service';
import { CommanService } from "src/app/shared/services/comman.service";
declare  var jQuery:  any;
import * as moment from  'moment';
@Component({
  selector: 'app-the-cross-bar',
  templateUrl: './the-cross-bar.component.html',
  styleUrls: ['./the-cross-bar.component.scss']
})
export class TheCrossBarComponent implements OnInit {
  hospitalityList: any = {};
  bannerrequest : any = {
    banner_type_name: "The Cross Bar"
  }
  bannerplayerList: any = "";
  constructor(
    public hospitalityService: HospitalityService,
    private commanService: CommanService
  ) { }

  ngOnInit() {
    this.loadbanner();
    this.hospitalityService.getTheCrossBar().then((data) => {
      this.hospitalityList = data.data;
      console.log(this.hospitalityList);
    });
  }

  loadbanner(){
    let request = Object.assign({}, this.bannerrequest);
    this.commanService.getBanner(request).then((data: any) => {
      this.bannerplayerList = data.data[0];
      console.log(this.bannerplayerList);
    });
  }

}
